import { By } from 'selenium-webdriver';
import { DriverLike, register } from '@oracle/oraclejet-webdriver';
import { DrawerLayoutWebElement } from './DrawerLayoutWebElement';
export { DrawerLayoutWebElement };

/**
 * Retrieve an instance of [DrawerLayoutWebElement](../classes/DrawerLayoutWebElement.html).
 * @example
 * ```javascript
 * import { findDrawerLayout } from '@oracle/oraclejet-core-pack/webdriver';
 * const el = await findDrawerLayout(driver, By.id('my-oj-c-drawer-layout'));
 * ```
 * @param driver A WebDriver/WebElement instance from where the element will be
 * searched. If WebDriver is passed, the element will be searched globally in the
 * document. If WebElement is passed, the search will be relative to this element.
 * @param by The locator with which to find the element
 */
export async function findDrawerLayout(
  driver: DriverLike,
  by: By
): Promise<DrawerLayoutWebElement> {
  const webEl = await driver.findElement(by);
  // Check that the element is of type DrawerLayoutWebElement
  if (!(webEl instanceof DrawerLayoutWebElement)) {
    const tagName = await webEl.getTagName();
    let supplemental = '';
    if (webEl.constructor.name === 'DrawerLayoutWebElement') {
      supplemental = 'You likely have multiple installations of this package.';
    }
    throw Error(
      `findDrawerLayout(${by}) created ${webEl.constructor.name} for <${tagName}>, but expected ${DrawerLayoutWebElement.name}. ${supplemental}`
    );
  }
  return webEl;
}

register('oj-c-drawer-layout', DrawerLayoutWebElement);
